import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router';

import { fireNewPermCandidateEmailLinkClicked } from '~/posthogs/events';

const POSTING_ID_PARAM = 'postingId';
const PROFESSIONAL_ID_PARAM = 'professionalId';
const UTM_SOURCE_PARAM = 'utm_source';
const UTM_MEDIUM_PARAM = 'utm_medium';

const EMAIL_SOURCE = 'email';
const DIRECT_APPLY_MEDIUM = 'direct_apply';

/**
 * Handles the Branch deep-link for the "Review Candidate" email CTA (GOTU-4403).
 *
 * The Branch `$desktop_url` lands at:
 *   /permanent-jobs/candidate-overview?postingId=<id>&professionalId=<id>&utm_source=email&utm_medium=direct_apply
 *
 * This component reads those params, fires the PostHog analytics event, and
 * performs a client-side redirect to the canonical candidate overview route:
 *   /permanent-jobs/<postingId>/candidates/<professionalId>/overview
 *
 * When either id is missing the link is malformed — fall back to the manage-jobs
 * page so the office sees something useful rather than a blank/error screen.
 */
export const CandidateOverviewRedirect = () => {
  const [searchParams] = useSearchParams();

  const postingId = searchParams.get(POSTING_ID_PARAM);
  const professionalId = searchParams.get(PROFESSIONAL_ID_PARAM);
  const utmSource = searchParams.get(UTM_SOURCE_PARAM);
  const utmMedium = searchParams.get(UTM_MEDIUM_PARAM);

  const isEmailLink = utmSource === EMAIL_SOURCE && utmMedium === DIRECT_APPLY_MEDIUM;

  useEffect(() => {
    if (isEmailLink) {
      fireNewPermCandidateEmailLinkClicked();
    }
  }, [isEmailLink]);

  if (!postingId || !professionalId) {
    return <Navigate to="/permanent-jobs/postings" replace />;
  }

  return (
    <Navigate
      to={`/permanent-jobs/${postingId}/candidates/${professionalId}/overview`}
      replace
    />
  );
};
